<template lang="pug">
  v-menu(v-model="menu" v-if="this.notifications.length"
    transition="slide-y-transition"
    bottom left 
    offset-y 
    :close-on-content-click="true"
    :nudge-width="350")
    v-btn(icon slot='activator')
      v-badge(color='red darken-4' overlap)
        template(slot="badge")
          span.caption.font-weight-regular {{ notificationsLength }}
        v-icon(medium) notifications
    v-card
      v-toolbar.elevation-0(height="45" color="gray")
        v-toolbar-title(style="width: 100%;")
          v-layout(align-center justify-space-between row)
            h1.subheading Notifications
            v-chip(small color="warning" dark)
              h1.subheading.text-xs-right {{ notifications.length }}
      v-list.list-500(two-line)
        template(v-for='(notification, index) in notifications')
          v-list-tile(avatar @click="open(notification)")
            v-list-tile-avatar
              img(v-if="notification.fromUser.imageUrl" :src='notification.fromUser.imageUrl')
              img(v-else src="../../../assets/images/user.jpeg")
            v-list-tile-content
              v-list-tile-title
                v-layout
                  span {{ notification.heading }}
                  v-spacer
                  span.caption {{ notification.createdAt | moment("from", "now") }}
              v-list-tile-sub-title
                div {{ notification.body }}
                  span.font-weight-bold.green--text {{ notification.fromUserName }}
          v-divider(v-if="index + 1 < notifications.length" :key="index" inset)
      // v-divider
      // v-list
      //   v-list-tile(@click="clearAll")
      //     v-list-tile-content
      //       v-list-tile-action {{ $t('labels.markAllRead') }}


</template>

<script>
import { mapGetters } from "vuex";
import toolbarService from "../service";
import sound from "../../../assets/audio/iphone_notification.mp3";

const audio = new Audio(sound);

export default {
  data: () => ({
    menu: false,
    notifications: []
  }),
  watch: {
    currentUser() {
      this.getNotifications(this.currentUser.userID);
    }
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    notificationsLength() {
      let value = 0;
      if (this.notifications.length > 9) {
        value = "9+";
      } else {
        value = this.notifications.length;
      }
      return value;
    }
    // notificationsMap() {
    //   const map = {};
    //   this.notifications.forEach(e => (map[this.$moment(e.createdAt).format("YYYY-MM-DD")] = map[this.$moment(e.createdAt).format("YYYY-MM-DD")] || []).push(e));
    //   console.log('map', map)
    //   return map
    // }
  },
  sockets: {
    notification(data) {
      this.getNotifications(this.currentUser.userID);
      audio.play();
      console.log("notification got");
    }
  },
  created() {
    this.getNotifications(this.currentUser.userID);
  },
  methods: {
    open(val) {
      this.$router.push({ path: `/${val.link}` });
      let indexID = this.notifications.findIndex(x => x.id === val.id);

      toolbarService.markRead(val.id).then(result => {
        if (result.data) {
          this.notifications.splice(indexID, 1);
        }
      });
    },
    clearAll(val) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      }).then(result => {
        if (result.value) {
          this.$Progress.start();
          return toolbarService
            .markAllRead(this.currentUser.userID)
            .then(response => {
              if (response.data) {
                this.$swal
                  .mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000
                  })
                  .fire({
                    type: "success",
                    title: "Notification was marked read!"
                  });
                this.getNotifications(this.currentUser.userID);
              }
              this.$Progress.finish();
            })
            .catch(error => {
              this.$toasted.error(error.data.message, {
                position: "top-right",
                showHideTransition: "slide",
                icon: "error",
                duration: 5000
              });
              this.$Progress.fail();
            });
        }
      });
    },
    getNotifications(id) {
      return toolbarService.getNotificationsByUser(id).then(result => {
        this.notifications = result.data;
      });
    }
  }
};
</script>

<style scoped></style>
